import React, { useContext } from "react";
import { Route as RouterRoute, Redirect, useLocation } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
  const { isAuth, loading, user } = useContext(AuthContext);
  const location = useLocation();

  if (!isAuth && isPrivate) {
    return (
      <>
        {loading && <BackdropLoading />}
        <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
      </>
    );
  }

  // Esperar el perfil antes de permitir una ruta privada.
  if (isAuth && isPrivate && (!user || !user.profile)) {
    return <BackdropLoading />;
  }

  // En este entorno aislado, repartidores y operadores
  // solo pueden navegar a la pantalla de conversaciones.
  // El backend verifica los permisos individuales.
  if (
    isAuth &&
    isPrivate &&
    ["repartidor", "user"].includes(user.profile) &&
    location.pathname !== "/tickets" &&
    !(user.profile === "user" && /^\/tickets\/[1-9][0-9]*$/.test(location.pathname))
  ) {
    return <Redirect to="/tickets" />;
  }

  if (isAuth && !isPrivate) {
    return (
      <>
        {loading && <BackdropLoading />}
        <Redirect to={{ pathname: "/", state: { from: rest.location } }} />;
      </>
    );
  }

  return (
    <>
      {loading && <BackdropLoading />}
      <RouterRoute {...rest} component={Component} />
    </>
  );
};

export default Route;
